import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Stripe, StripeElements } from '@stripe/stripe-js';
import { connect } from 'react-redux';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import { padStart, resolveTextWithLinks } from '../helpers/util';
import { Column, Button, Small, Link, Divider, Center, Bold } from './styled';
import { LoaderButton } from '.';
import { appActions } from '../store/ducks/app';
import { modalActions } from '../store/ducks/modal';
import { FlexBaseLine } from './styled/Flex';
import { LinkUpdate } from './styled/Link';

interface State {
  agreementChecked: boolean;
}

interface OwnProps {
  stripe?: Stripe | null;
  elements?: StripeElements | null;
  intl?: any;
  update?: boolean;
}

const mapStateToProps = (state: any) => ({
  paymentIsBusy: state.appData.payment.isBusy,
  validationError: state.appData.payment.validationError,
  agreementError: state.appData.payment.agreementError,
  general: state.appData.general,
  language: state.appData.language,
  paymentMethod: state.appData.user.paymentMethod,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  startPayment: (cardName: string, stripe: any, element: any, agreement: boolean) => void;
  switchError: (errorName: string, error: boolean) => void;
  toggleInputCardDetailsModal: (isOpen: boolean) => void;
}
type Props = OwnProps & StateProps & DispatchProps;

class PaymentInformation extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      agreementChecked: false,
    };
  }

  switchAgreement = () => {
    this.setState({ agreementChecked: !this.state.agreementChecked });
    this.props.switchError('agreementError', false);
  };

  handlePayment = (event: any) => {
    // We don't want to let default form submission happen here, which would refresh the page.
    event.persist();
    event.preventDefault();
    const agreement = !((!this.props.update && !this.state.agreementChecked));
    this.props.startPayment('', this.props.stripe, this.props.elements, agreement);
  }

  handleLinkInputCardDetails = (_event: any) => {
    this.props.toggleInputCardDetailsModal(true);
  }

  render() {
    if (!this.props.paymentMethod) {
      return <Link onClick={this.handleLinkInputCardDetails}><FormattedMessage id="add_credit_card" /></Link>;
    }
    return (
      <>
        <FlexBaseLine>
          <Small><FormattedMessage id="credit_card" /></Small>
          <Bold>XXXX - XXXX - XXXX - { this.props.paymentMethod?.last4Digits || '----' }</Bold>
        </FlexBaseLine>
        <FlexBaseLine>
          <Small><FormattedMessage id="expires" /></Small>
          <Bold>{ padStart(this.props.paymentMethod.expirationMonth, 2, '0') || '--' } / { this.props.paymentMethod.expirationYear || '----' }</Bold>
        </FlexBaseLine>
        <LinkUpdate onClick={this.handleLinkInputCardDetails}><FormattedMessage id="update_credit_card" /></LinkUpdate>
        {
          !this.props.update && (
            <>
              <Divider />
              {
                this.props.validationError && (
                  <Column>
                    <Small red={true}>
                      { this.props.intl.formatMessage({ id: this.props.validationError, defaultMessage: 'Something went wrong, please refresh.' }) }
                    </Small>
                  </Column>
                )
              }
              <Column>
                <Small><FormattedMessage id="payment_provider" /></Small>
              </Column>
              <Column>
                <div className="form-group">
                  <div className="form-group--checkbox">
                    <span onClick={this.switchAgreement} className={this.state.agreementChecked ? 'checkbox checkbox--active' : 'checkbox'} />
                    <Small red={this.props.agreementError}>{
                      resolveTextWithLinks(
                        this.props.intl.formatMessage({ id: 'agreement' }),
                        [`${this.props.general.config.termsOfUseLink}${this.props.language}/`,
                          `${this.props.general.config.privacyPolicyLink}${this.props.language}/`]
                      )
                    }
                    </Small>
                  </div>
                </div>
              </Column>
              <Center>
                <Button type="button" onClick={this.handlePayment} disabled={!this.props.stripe || this.props.paymentIsBusy}>
                  { this.props.paymentIsBusy ? <LoaderButton /> : <FormattedMessage id="confirm_subscription" /> }
                </Button>
              </Center>
            </>
          )
        }
      </>
    );
  }
}

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, { ...appActions, ...modalActions })(injectIntl(injectedCheckoutForm));

export function injectedCheckoutForm(props: Props) {
  return (
    <ElementsConsumer>
      { ({ stripe, elements }) => <PaymentInformation {...props} stripe={stripe} elements={elements} /> }
    </ElementsConsumer>
  );
}
